/**
 * Query param carrying the id of the block (task/message) or action
 * (automation) selected in a read-only timeline-item dialog, so the editor
 * opens with the same selection. The shared route builder doesn't know this
 * param, so it is appended to the edit URL here and read back by the editor
 * page with the same constant.
 */
export const SELECTED_BLOCK_QUERY_PARAM = 'b';

/** Appends the selected block/action id to an edit URL; no-op without an id. */
export const withSelectedBlockParam = (
  url: string,
  selectedBlockId: string | null | undefined
): string =>
  selectedBlockId
    ? `${url}${
        url.includes('?') ? '&' : '?'
      }${SELECTED_BLOCK_QUERY_PARAM}=${encodeURIComponent(selectedBlockId)}`
    : url;
